import { Property } from "src/api/sure-api/ssq/useGetOneSsqVersion";

type OverrideProperty = {
    propertyDataList: Property["dataList"];
    propertyDefaultValue: Property["defaultValue"];
    propertyGenericValue: Property["genericValue"];
    propertyHelperText: Property["helperText"];
    propertyTitle: Property["title"];
    propertyReadonly: Property["readonly"];
};

type Options = {
    originalProperty: Property;
    potentialOverrides: Partial<OverrideProperty> | undefined;
    ingredientGenericValue?: string;
};
export const overrideProperty = (options: Options): Property => {
    const { originalProperty, potentialOverrides, ingredientGenericValue } = options;
    const newProperty = { ...originalProperty };

    newProperty.title = potentialOverrides?.propertyTitle || originalProperty.title;
    newProperty.dataList = potentialOverrides?.propertyDataList || originalProperty.dataList;
    newProperty.helperText = potentialOverrides?.propertyHelperText || originalProperty.helperText;
    newProperty.defaultValue = potentialOverrides?.propertyDefaultValue || originalProperty.defaultValue;
    newProperty.genericValue =
        ingredientGenericValue || potentialOverrides?.propertyGenericValue || originalProperty.genericValue;
    newProperty.readonly =
        potentialOverrides?.propertyReadonly !== undefined && potentialOverrides.propertyReadonly !== null ?
            potentialOverrides.propertyReadonly
        :   originalProperty.readonly;

    return newProperty;
};
